import { PROGRESS } from 'config/config';
import { getContainerHeight, loadScript } from 'helpers/commonHelper';
import React, { createRef, PureComponent, RefObject } from 'react';

import { RouteComponentProps } from 'react-router';
import { getApplePayPaymentConfig } from 'services/Api';
import { withRouter } from 'react-router-dom';
import { IApplePayConfigurationContext } from '../../types/applepay/ApplePayConfigurationContext';
import { ApplePayConfiguration } from '../../types/applepay/ApplePayConfiguration';
import ApplePayDetailsContainer from './ApplePay.styles';
import withApplePayConfigurationContext from '../../hoc/WithApplePayConfigurationContext';
import withContext from '../../hoc/withContext';
import withTextContext from '../../hoc/withTextContext';

interface IProps extends IAccordionWrapper, IContext, RouteComponentProps<{ paymentId: string }> {
  paymentMethods: IMethod[];
}

class ApplePay extends PureComponent<IProps & IApplePayConfigurationContext> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  applePayPaymentMethodId = '';

  async componentDidMount() {
    const {
      paymentMethods,
      setHeight,
      applePayConfiguration,
      setApplePayConfiguration,
      isApplePayScriptLoaded,
      setIsApplePayScriptLoaded,
      match: {
        params: { paymentId },
      },
    } = this.props;

    try {
      if (!isApplePayScriptLoaded) {
        await loadScript(process.env.REACT_APP_APPLE_PAY_SDK_URL as string).then(() => {
          setIsApplePayScriptLoaded(true);
        });
      }

      setHeight(getContainerHeight(this.containerRef.current));
      this.applePayPaymentMethodId = paymentMethods[0].id;

      if (applePayConfiguration === undefined || Object.keys(applePayConfiguration).length === 0) {
        const configuration = (await getApplePayPaymentConfig(paymentId)) as ApplePayConfiguration;
        setApplePayConfiguration(configuration);
      }
    } catch (error) {
      this.setState(() => {
        throw error;
      });
    }
  }

  componentDidUpdate() {
    if (this.shouldRefreshState()) {
      const { setHeight } = this.props;
      setHeight(getContainerHeight(this.containerRef.current));
    }
  }

  shouldRefreshState() {
    const { paymentMethodId, progress } = this.props;

    return this.applePayPaymentMethodId === paymentMethodId && progress < PROGRESS.SELECT_APPLE_PAY_METHOD;
  }

  render() {
    return <ApplePayDetailsContainer className="apple-pay__container" ref={this.containerRef} />;
  }
}

export default withContext(withTextContext(withApplePayConfigurationContext(withRouter(ApplePay))));
